// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6600c535","498":"b822d7b1","703":"915c93cb","787":"927ede21"}[chunkId] + ".chunk.js";
};